export default {
  'menu.home': '首页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.account': '账户',
  'menu.account.logout': '退出登录',
  'menu.account.settings': '账户设置',
  'menu.account.staff-management': '员工管理',
  'menu.account.partner-grants': '商家授权',
  'menu.account.adminInvitations': '管理员邀请',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',

  // Adyen Balance Platform menus
  'menu.dashboard': '仪表盘',
  'menu.fees': '手续费',
  'menu.merchants': '商户管理',
  'menu.merchants.list': '商户列表',
  'menu.merchants.detail': '商户详情',
  'menu.merchant-details': '商户详情',
  'menu.balance-accounts': '余额账户',
  'menu.balance-account-detail': '余额账户详情',
  'menu.transactions': '交易记录',
  'menu.payouts': '支付管理',
  'menu.reports': '报表中心',
  'menu.disputes': '争议处理',
  'menu.settings': '系统设置',

  // Admin menus (SuperAdmin only)
  'menu.admin': '管理后台',
  'menu.admin.merchantOwners': '商户所有者',
  'menu.admin.splitConfigurations': '分账配置',
  'menu.admin.surchargeProfiles': '费率模板',
  'menu.admin.accessRequests': '商户访问审批',
  'menu.accessRequests': '商户访问审批',
  'menu.adminInvitations': '管理员邀请',
  'menu.admin.adminInvitations': '管理员邀请',
  'menu.admin.adminSettings': '账户设置',
};
